import axios from 'axios';
import store from '../store.js';
// Add a request interceptor
var companyApi = axios.create({});
companyApi.interceptors.request.use(config => {
    const token = store.state.auth.access_token
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + store.state.auth.access_token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
}, error => {
    Promise.reject(error)
});
//Add a response interceptor
companyApi.interceptors.response.use((response) => {
    return response
}, function(error) {
    console.log(error);
    const originalRequest = error.config;
    if ((error.response.status === 401 || error.response.status === 400) && originalRequest.url === 'https://id.magico.pro/api/v1/token') {
        localStorage.clear();
        console.log('asdasdasdasdasdasddaasd');
        window.location.replace('/');
        return Promise.reject(error);
    }
    if ((error.response.status === 401 || error.response.status === 400) && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshToken = store.state.auth.refresh_token
        return axios.post('https://id.magico.pro/api/v1/token', {
            'grant_type': 'refresh_token',
            'client_id': 'helpdesk',
            "refresh_token": refreshToken
        }).then(res => {
            if (res.status === 200) {
                console.log(res.data);
                store.dispatch('auth/setToken', res.data);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.auth.access_token;
                return axios(originalRequest);
            }
        }, error => {
            localStorage.clear();
            window.location.replace('/');

        })
    }
    return Promise.reject(error);
});
export default companyApi;